/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxRouter = require('redux-router');

var _reactRedux = require('react-redux');

var SearchField = (function (_Component) {
	_inherits(SearchField, _Component);

	function SearchField() {
		var _this = this;

		_classCallCheck(this, _SearchField);

		_Component.apply(this, arguments);

		this.state = {
			value: this.props.value
		};

		this.handleChange = function (event) {
			_this.setState({ value: event.target.value });
		};

		this.handleKeyPress = function (event) {
			if (event.key === 'Enter') {
				_this.handleSearch();
			}
		};

		this.handleSearch = function () {
			var dest = '/search/' + _this.state.value;
			_this.props.pushState(null, dest);
			if (_this.props.onSearch) _this.props.onSearch();
		};
	}

	SearchField.prototype.render = function render() {
		var styles = require('./SearchField.css');
		var value = this.state.value;

		return _react2['default'].createElement(
			'div',
			{ className: styles.SearchForm },
			_react2['default'].createElement('input', { type: 'text', autoFocus: true, className: styles.SearchField, value: value, onChange: this.handleChange, onKeyPress: this.handleKeyPress }),
			_react2['default'].createElement('button', { className: styles.SearchButton, onClick: this.handleSearch })
		);
	};

	_createClass(SearchField, null, [{
		key: 'propTypes',
		value: {
			onSearch: _react.PropTypes.func,
			pushState: _react.PropTypes.func,
			value: _react.PropTypes.string
		},
		enumerable: true
	}]);

	var _SearchField = SearchField;
	SearchField = _reactRedux.connect(function (state) {
		return {
			q: state.router.location.query.q
		};
	}, { pushState: _reduxRouter.pushState })(SearchField) || SearchField;
	return SearchField;
})(_react.Component);

exports['default'] = SearchField;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SearchField/SearchField.js
 ** module id = 690
 ** module chunks = 0
 **/